import { render, staticRenderFns } from "./AiChatComponent.vue?vue&type=template&id=5e2f4340&scoped=true"
import script from "./AiChatComponent.vue?vue&type=script&lang=js"
export * from "./AiChatComponent.vue?vue&type=script&lang=js"
import style0 from "./AiChatComponent.vue?vue&type=style&index=0&id=5e2f4340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f4340",
  null
  
)

export default component.exports